<script lang="ts" setup>
  import { Toaster as Sonner, type ToasterProps } from 'vue-sonner'

  const props = defineProps<ToasterProps>()
</script>

<template>
  <Sonner
    class="toaster group"
    v-bind="props"
    :toast-options="{
      classes: {
        toast:
          'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
        description: 'group-[.toast]:text-muted-foreground',
        actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
        cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground'
      }
    }"
  />
</template>

<style>
  [data-sonner-toast] {
    height: auto !important;
    min-height: fit-content !important;
  }

  [data-sonner-toast] [data-content] {
    overflow: visible !important;
    height: auto !important;
    min-height: fit-content !important;
  }

  [data-sonner-toast] [data-description] {
    overflow-wrap: break-word;
    word-break: break-word;
    white-space: normal;
  }
</style>
